
import Vue from "vue";
import { DossierConfigService } from "@/services";
import AppSelectBankType from "@/components/bank/SelectBankType.vue";
import AppLedgerAccountAutocomplete from "@/components/common/LedgerAccountAutocomplete.vue";
import { TERMINALS_WITH_COST_BOOKING, TerminalID } from "@/models/dossier-configs/bank-config";

export default Vue.extend({
	data(){
		return {
			settings: DossierConfigService.getBankConfig(),
			saving: false
		};
	},
	methods: {
		getTerminalName(terminal:TerminalID):string {
			return this.$ct(`terminal-name-${terminal.toLowerCase().replace(/_/g, "-")}`).toString();
		},
		hasCostBooking(terminal:TerminalID):boolean {
			return TERMINALS_WITH_COST_BOOKING.indexOf(terminal) != -1;
		},
		async save(){
			if (this.saving) return;
			this.saving = true;
			try{
				for (let booking of this.settings.TerminalBookings){
					booking.BankTypeID = booking.BankTypeID || 0;
					booking.CostLedgerAccountCode = booking.CostLedgerAccountCode || "";
				}
				let config = DossierConfigService.getBankConfig();
				config.ProcessTerminalTransactions = this.settings.ProcessTerminalTransactions;
				config.TerminalBookings = this.settings.TerminalBookings;
				config.TerminalTransferLedgerAccountCode = this.settings.TerminalTransferLedgerAccountCode;
				this.settings = await DossierConfigService.setBankConfig(config);
				this.$wf.notify(this.$ct("common.success").toString(), "success", 3000, "check");
			}catch(err){

			}
			this.saving = false;
		}
	},
	components: {
		AppSelectBankType,
		AppLedgerAccountAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
